import Vue from 'vue';
export function httpCreate(data) {
  return  Vue.$axios({
    // url: '/api/wallet/public/hdCreate',
    url: 'https://wallet-hd.hammermining.com/hdWallets/api/user/login',
    headers: {
      'Content-Type': 'application/json',
      'charset': 'UTF-8'
    },
    method: 'post',
    data
  })
}

export function httpInit(data) {
  return  Vue.$axios({
    url: 'https://wallet-hd.hammermining.com/hdWallets/api/address/initAddress',
    headers: {
      'Content-Type': 'application/json',
      'charset': 'UTF-8'
    },
    method: 'post',
    data
  })
}

export function httpChainList(params) {
  return  Vue.$axios({
    url: 'https://wallet-hd.hammermining.com/hdWallets/api/chain/getChainList',
    headers: {
      'Content-Type': 'application/json',
      'charset': 'UTF-8'
    },
    method: 'get',
    params
  })
}

export function httpList(params) {
  return  Vue.$axios({
    url: 'https://wallet-hd.hammermining.com/hdWallets/api/address/getAddressList',
    headers: {
      'Content-Type': 'application/json',
      'charset': 'UTF-8'
    },
    method: 'get',
    params
  })
}

export function httpAddList(params) {
  return  Vue.$axios({
    url: 'https://wallet-hd.hammermining.com/hdWallets/api/coin/getCoinList',
    method: 'get',
    params
  })
}

export function httpCoinSearch(params) {
  return  Vue.$axios({
    url: 'https://wallet-hd.hammermining.com/hdWallets/api/coin/getCoinList',
    method: 'get',
    params
  })
}

export function httpCoinAdd(data) {
  return  Vue.$axios({
    url: 'https://wallet-hd.hammermining.com/hdWallets/api/coin/addCoinAddress',
    method: 'post',
    data
  })
}

export function httpCoinDel(data) {
  return  Vue.$axios({
    url: 'https://wallet-hd.hammermining.com/hdWallets/api/coin/deleteCoinAddress',
    method: 'delete',
    data
  })
}

export function httpCoinBalance(params) {
  return  Vue.$axios({
    url: 'https://wallet-hd.hammermining.com/hdWallets/api/coin/getCoinBalance',
    method: 'get',
    params
  })
}

export function httpCoinDetail(params) {
  return  Vue.$axios({
    url: 'https://wallet-hd.hammermining.com/hdWallets/api/coin/getSymbolInfo',
    method: 'get',
    params
  })
}

export function httpCoinRecord(params) {
  return  Vue.$axios({
    url: 'https://wallet-hd.hammermining.com/hdWallets/api/transaction/getUserTransactionList',
    method: 'get',
    params
  })
}

export function httpCoinFee(params) {
  return Vue.$axios({
    url: 'https://wallet-hd.hammermining.com/hdWallets/api/coin/getFee',
    method: 'get',
    params
  })
}

export function httpHDCoinSend(data) {
  return  Vue.$axios({
    url: 'https://wallet-hd.hammermining.com/hdWallets/api/transaction/sendRawTransaction',
    method: 'post',
    data
  })
}

export function httpCoinCode(data) {
  return  Vue.$axios({
    url: '/api/wallet/hd_account/address',
    method: 'post',
    data
  })
}
